<template>
	<vx-card>
		<vs-popup
			:active.sync="showMissionsPopup"
			:title="'Prestations du contrat N°' + selectedContract"
		>
			<div style="width: 1000px">
				<MissionPopupTable :missions="missionsOfSociety" />
			</div>
		</vs-popup>

		<div class="vx-col">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<h3>Modifier un achat</h3>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-button
						class="float-right"
						radius
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-x"
						@click="returnPrevRoute"
					></vs-button>
				</div>
			</div>

			<div class="vx-row justify-start">
				<!-- CLIENT -->
				<div class="vx-col sm:w-1/8 mb-2">
					<label for="" class="vs-select--label text-right block">Client</label>
					<div class="flex justify-end">
						<vs-select
							v-model="selectedSociety"
							class="w-full select-medium mr-2"
							:disabled="
								purchaseDefinitiveLock || recurringPurchaseLock || isLoading
							"
							autocomplete
							:style="styleValidator('selectedSociety')"
							@change="onSocietyChange"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in societies"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedSociety'] &&
								validators['selectedSociety'].errText !== ''
							"
							:text="errText('selectedSociety')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>

				<!-- CONTRAT -->
				<div class="vx-col sm:w-1/8 mb-2" v-if="!is_dns">
					<label for="" class="vs-select--label text-right block"
						>Contrat</label
					>
					<div class="flex justify-end">
						<vs-select
							autocomplete
							v-model="selectedContract"
							class="w-full select-medium mr-2"
							:disabled="
								purchaseLocked ||
								recurringPurchaseLock ||
								isLoading ||
								!contractOptions.length
							"
							:style="styleValidator('selectedContract')"
							@change="onContractChange"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.id + ' - ' + products_categories[item.delivery - 1]"
								v-for="(item, index) in contractOptions"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedContract'] &&
								validators['selectedContract'].errText !== ''
							"
							:text="errText('selectedContract')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>

				<!-- PRESTATION -->
				<div class="vx-col sm:w-1/8 mb-2" v-if="!is_dns">
					<label for="" class="vs-select--label text-right block"
						>Prestation</label
					>
					<div class="flex justify-end">
						<vs-select
							autocomplete
							v-model="selectedProduct"
							class="w-full select-medium mr-2"
							:disabled="
								purchaseLocked ||
								recurringPurchaseLock ||
								isLoading ||
								!productOptions.length
							"
							no-data="Aucune prestation"
							:style="styleValidator('selectedProduct')"
							@change="onProductChange"
							id="product_options"
						>
							<vs-select-item
								:key="index"
								:value="item[0]"
								:text="item[1]"
								v-for="(item, index) in productOptions"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedProduct'] &&
								validators['selectedProduct'].errText !== ''
							"
							:text="errText('selectedProduct')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>

				<!-- SERVICE -->
				<div class="vx-col sm:w-1/4 mb-2">
					<label for="" class="vs-select--label text-right block"
						>Service</label
					>
					<div class="flex justify-end">
						<vs-select
							v-model="selectedService"
							class="w-full select-medium mr-2"
							:disabled="
								purchaseDefinitiveLock ||
								recurringPurchaseLock ||
								isLoading ||
								!serviceOptions.length
							"
							autocomplete
							:style="styleValidator('selectedService')"
							@change="onServiceChange"
						>
							<vs-select-item
								:key="index"
								:value="item"
								:text="getServiceName(item)"
								v-for="(item, index) in serviceOptions"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedService'] &&
								validators['selectedService'].errText !== ''
							"
							:text="errText('selectedService')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>

				<!-- PRESTATAIRE -->
				<div class="vx-col sm:w-1/8 mb-2">
					<label for="" class="vs-select--label text-right block"
						>Prestataire</label
					>
					<div class="flex justify-end">
						<vs-select
							v-model="selectedProvider"
							class="w-full select-medium mr-2"
							:disabled="
								purchaseDefinitiveLock || recurringPurchaseLock || isLoading
							"
							autocomplete
							:style="styleValidator('selectedProvider')"
							@change="onProviderChange"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.society"
								v-for="(item, index) in providers"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedProvider'] &&
								validators['selectedProvider'].errText !== ''
							"
							:text="errText('selectedProvider')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>

			<!-- Rest of the form remains the same... -->
			<div class="vx-row justify-start">
				<!-- PRIX D'ACHAT -->
				<div
					v-if="
						![
							netlinkServiceId,
							netlinkClientServiceId,
							dnsServiceId,
							dnsClientServiceId,
						].includes(selectedService)
					"
					class="vx-col sm:w-1/5 w-full mb-2 mt-2"
				>
					<label class="vs-input--label text-left block">Prix d'achat</label>
					<div class="flex justify-end items-center">
						<vs-input
							class="w-full"
							:disabled="purchaseLocked"
							v-model="selectedPrice"
							:style="styleValidator('selectedPrice')"
							@change="validateOne(selectedPrice, 'selectedPrice')"
						/>
						<span class="ml-2">€</span>
						<vx-tooltip
							v-if="
								validators['selectedPrice'] &&
								validators['selectedPrice'].errText !== ''
							"
							:text="errText('selectedPrice')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>

				<!-- REFACTURABLE -->
				<div class="vx-col sm:w-1/5 w-full m-8">
					<!-- <label class="text-right block mb-2">Facturation</label> -->
					<div class="flex justify-start items-center">
						<vs-checkbox
							:disabled="
								purchaseLocked || recurringPurchaseLock || lockBillable
							"
							v-model="purchase.isBillable"
							>Facturable</vs-checkbox
						>
					</div>
				</div>

				<div
					v-if="is_dns == false && purchase.isBillable"
					class="vx-col sm:w-1/5 w-full mb-2"
				>
					<label class="vs-input--label text-right block">Prix de vente</label>
					<div class="flex justify-end items-center">
						<vs-input
							class="w-full"
							:disabled="purchaseLocked || recurringPurchaseLock"
							v-model="selectedSellPrice"
							:style="styleValidator('selectedSellPrice')"
							@change="validateOne(selectedSellPrice, 'selectedSellPrice')"
						/>
						<span class="ml-2">€</span>
						<vx-tooltip
							v-if="
								validators['selectedSellPrice'] &&
								validators['selectedSellPrice'].errText !== ''
							"
							:text="errText('selectedSellPrice')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>

			<div class="vx-row w-full mb-2" style="margin-left: 0px; margin-top: 5px">
				<vx-input-group class="bottom">
					<label for="flatpickr" style="font-size: 9px; margin-left: 3px"
						>Période</label
					>
					<br />
					<flat-pickr
						id="flatpickr"
						v-model="purchase.period_date"
						:config="configDatePickerMonth"
						style="width: 100px; text-align: center"
						@keydown.native.delete.capture.stop.prevent
						:disabled="purchaseLocked || recurringPurchaseLock"
					/>
				</vx-input-group>
			</div>

			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-textarea
						v-model="purchase.commentary"
						label="Commentaire"
						class="mb-0 md:mt-10 mt-6"
						:disabled="purchaseLocked || recurringPurchaseLock"
					/>
				</div>
			</div>

			<div class="vx-row justify-between mt-2 mb-2">
				<div class="vx-col" v-if="!is_dns && selectedContract">
					<vs-button
						color="primary"
						type="filled"
						@click="displayMissionsPopup"
					>
						Voir les prestations du contrat
					</vs-button>
				</div>

				<div class="vx-col">
					<vs-button
						v-if="purchaseLocked"
						class="float-right"
						color="primary"
						type="filled"
						@click="enterEditMode"
						>Modifier Achat</vs-button
					>
				</div>
			</div>

			<div class="vx-row">
				<div class="vx-col w-full mb-2">
					<span
						v-show="showNetlinkPopup && selectedService == netlinkServiceId"
					>
						<NetlinkPopupTable
							ref="netlinkPopup"
							:isEdit="true"
							:purchaseId="purchaseId"
							:societyId="selectedSociety"
							:disable="recurringPurchaseLock"
							@b-update="checkNetlinkNumber($event)"
						/>
					</span>
					<span v-show="showDnsPopup && selectedService == dnsServiceId">
						<DnsPopupTable
							ref="dnsPurchasePopup"
							:purchaseId="purchaseId"
							:providerId="selectedProvider"
							:price="Number(purchase.price)"
						/>
					</span>
				</div>
			</div>

			<div class="vx-row float-right mt-3">
				<div class="vx-col w-full">
					<vs-button
						v-if="is_netlink && !showNetlinkPopup"
						class="mb-2"
						@click="formSubmittedAndShowNetlink"
						>Enregistrer et Ajouter Netlink</vs-button
					>
					<vs-button
						v-if="is_dns && !showDnsPopup"
						class="mb-2"
						@click="formSubmittedAndShowDns"
						>Enregistrer et Ajouter NDD</vs-button
					>
					<vs-button v-else class="mb-2" @click="submitForm"
						>Enregistrer</vs-button
					>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import NetlinkPopupTable from "@/components/tables/NetlinkPopupTable";
import DnsPopupTable from "@/components/tables/DnsPopupTable";
import Purchase from "@/entities/Purchase";
import Contract from "@/entities/Contract";
import Provider from "@/entities/Provider";
import Validator from "@/entities/Validator";
import Mission from "@/entities/Mission";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "UpdatePurchaseForm",
	mixins: [dbFieldConvertor],
	props: {
		chartParams: Object,
		isPercent: Boolean,
	},
	components: {
		flatPickr,
		monthSelect,
		MissionPopupTable,
		NetlinkPopupTable,
		DnsPopupTable,
		VxTooltip,
	},
	data() {
		return {
			// Loading state
			isLoading: false,
			isInitialized: false,

			// USER OBJECT
			purchase: Purchase.getFormFields(),
			purchaseOld: Purchase.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,

			// FORM SELECT OPTIONS
			statusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "Inactif", value: 0 },
			],
			frequencyOptions: [
				{ text: "One shot", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Bimestriel", value: 2 },
				{ text: "Trimestriel", value: 3 },
				{ text: "Quadrimestriel", value: 4 },
				{ text: "Semestriel", value: 5 },
				{ text: "Annuel", value: 6 },
			],
			typeOptions: [
				{ text: "Commercial", value: 2 },
				{ text: "Consultant", value: 3 },
			],

			// Dynamic options
			contractOptions: [],
			productOptions: [],
			providerOptions: [],
			serviceOptions: [],
			missionsOfSociety: [],

			// Selected values
			selectedSociety: null,
			selectedContract: null,
			selectedProduct: null,
			selectedProvider: null,
			selectedService: null,
			selectedDate: null,
			selectedPrice: 0,
			selectedSellPrice: 0,
			selectedMarginPrice: 0,

			// States
			purchaseLocked: false,
			purchaseDefinitiveLock: false,
			lockBillable: false,
			recurringPurchaseLock: false,

			// Service flags
			is_netlink: false,
			is_netlinkclient: false,
			is_dns: false,
			is_dnsclient: false,

			// Service names and IDs
			netlinkServiceName: "Netlinking",
			netlinkClientServiceName: "Netlinking Client",
			dnsClientServiceName: "Domaine Client",
			dnsServiceName: "Domaine",
			netlinkServiceId: null,
			netlinkClientServiceId: null,
			dnsClientServiceId: null,
			dnsServiceId: null,

			// Popup states
			showDnsPopup: false,
			showNetlinkPopup: false,
			showMissionsPopup: false,
			atLeastOneNetlink: false,

			// Other
			purchaseId: null,
			today: new Date(Date.now()),
			validators: {},
			check: true,
			period: null,

			configDatePickerMonth: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
		};
	},

	async mounted() {
		try {
			this.isLoading = true;
			await this.initializeForm();
		} catch (error) {
			console.error("Error initializing form:", error);
			this.$vs.notify({
				title: "Erreur",
				text: "Erreur lors du chargement du formulaire.",
			});
		} finally {
			this.isLoading = false;
		}
	},

	computed: {
		activeUser: () => VueCookies.get("userInfo"),
		societies: () => store.state.societies,
		products: () => store.state.products,
		providers: () => store.state.providers,
		services: () => store.state.services,
		products_categories: () =>
			store.state.products_categories.map((row) => row.name),
	},

	methods: {
		// ====================
		// INITIALIZATION METHODS
		// ====================
		async initializeForm() {
			// Initialize basic data
			let today = new Date(Date.now());
			this.period = `${today.getMonth() + 1}/${today.getFullYear()}`;
			this.purchase.boughtAt = today.toISOString();

			// Load all required data
			await Promise.all([
				this.getAllProductsCategories(),
				this.getAllDns(),
				this.getAllSocieties(),
				this.$store.dispatch("getAllProducts"),
				this.getAllProviders(),
				this.getAllServices(),
			]);

			// Set service IDs after services are loaded
			this.setNetlinkAndDnsId();

			// Load purchase data
			if (this.$route.params.recurrencePurchaseId) {
				await this.loadRecurrencePurchase();
			} else {
				await this.loadPurchase();
			}

			this.isInitialized = true;
		},

		async loadPurchase() {
			try {
				const response = await this.$http.get(
					this.apiUrl + "purchase/get/" + this.$route.params.purchaseId
				);

				this.purchase = new Purchase(response.data[0]);
				this.purchaseOld = new Purchase(response.data[0]);
				this.purchaseId = this.purchase.id;

				// Set form values
				await this.setPurchaseFormValues();
			} catch (error) {
				console.error("Error loading purchase:", error);
				throw error;
			}
		},

		async loadRecurrencePurchase() {
			try {
				this.recurringPurchaseLock = true;
				const response = await this.$http.get(
					this.apiUrl +
						"purchase/getrc/" +
						this.$route.params.recurrencePurchaseId
				);

				this.purchase = new Purchase(response.data[0]);
				this.purchaseOld = new Purchase(response.data[0]);
				this.purchaseId = this.purchase.id;
				this.recurrencePurchaseId = this.purchase.recurrence_id;

				// Set form values
				await this.setPurchaseFormValues();
			} catch (error) {
				console.error("Error loading recurrence purchase:", error);
				throw error;
			}
		},

		async setPurchaseFormValues() {
			// Set basic values
			this.selectedSociety = this.purchase.contract_society_id;
			this.selectedContract = this.purchase.contract_id;
			this.selectedProduct = this.purchase.mission_id;
			this.selectedProvider = this.purchase.users_id;
			this.selectedDate = this.purchase.boughtAt;
			this.selectedPrice = this.convertInternationalNumberToFrench(
				this.purchase.price
			);
			this.selectedSellPrice = this.convertInternationalNumberToFrench(
				this.purchase.sellPrice
			);
			this.selectedMarginPrice = this.convertInternationalNumberToFrench(
				this.purchase.marginPrice
			);

			// Load dependent data in sequence
			if (this.selectedSociety) {
				await this.loadContractsForSociety(this.selectedSociety);
			}

			if (this.selectedContract || this.is_dns) {
				await this.loadMissionsForContract(
					this.is_dns ? 1 : this.selectedContract
				);
			}

			if (this.selectedProvider) {
				await this.loadServiceOptionsAndSetService(
					this.selectedProvider,
					this.purchase.service_id
				);
			}
		},

		// ====================
		// EVENT HANDLERS
		// ====================
		async onSocietyChange(societyId) {
			if (!this.isInitialized) return;

			try {
				this.isLoading = true;
				this.purchase.contract_society_id = societyId;

				// Reset dependent fields
				this.selectedContract = null;
				this.selectedProduct = null;
				this.contractOptions = [];
				this.productOptions = [];

				if (societyId) {
					await this.loadContractsForSociety(societyId);

					if (this.is_dns) {
						await this.loadMissionsForContract(1);
					}
				}

				this.validateOne(societyId, "selectedSociety");
			} catch (error) {
				console.error("Error changing society:", error);
			} finally {
				this.isLoading = false;
			}
		},

		async onContractChange(contractId) {
			if (!this.isInitialized) return;

			try {
				this.isLoading = true;
				this.purchase.contract_id = contractId;

				// Reset dependent fields
				this.selectedProduct = null;
				this.productOptions = [];

				if (contractId) {
					await this.loadMissionsForContract(this.is_dns ? 1 : contractId);
				}

				this.validateOne(contractId, "selectedContract");
			} catch (error) {
				console.error("Error changing contract:", error);
			} finally {
				this.isLoading = false;
			}
		},

		onProductChange(productId) {
			if (!this.isInitialized) return;
			this.purchase.mission_id = productId;
			this.validateOne(productId, "selectedProduct");
		},

		async onProviderChange(providerId) {
			if (!this.isInitialized) return;

			try {
				this.isLoading = true;
				this.purchase.users_id = providerId;

				// Reset service
				this.selectedService = null;
				this.serviceOptions = [];

				if (providerId) {
					await this.loadServiceOptionsForProvider(providerId);
				}

				this.validateOne(providerId, "selectedProvider");
			} catch (error) {
				console.error("Error changing provider:", error);
			} finally {
				this.isLoading = false;
			}
		},

		onServiceChange(serviceId) {
			if (!this.isInitialized) return;

			this.purchase.service_id = serviceId;
			this.updateServiceFlags(serviceId);

			// Handle special service logic
			if (this.is_dns && this.selectedSociety) {
				this.loadMissionsForContract(1);
			} else if (!this.is_dns && this.selectedContract) {
				this.loadMissionsForContract(this.selectedContract);
			}

			// Handle billing lock
			if (this.is_dnsclient || this.is_netlinkclient) {
				this.purchase.isBillable = true;
				this.lockBillable = true;
			} else {
				this.lockBillable = false;
			}

			// Handle popups
			if (this.is_netlink) {
				this.showNetlink();
				this.purchaseLocked = true;
				this.purchaseDefinitiveLock = true;
			} else {
				this.showNetlinkPopup = false;
			}

			if (this.is_dns) {
				this.showDnsPopup = true;
			}

			this.validateOne(serviceId, "selectedService");
		},

		// ====================
		// DATA LOADING METHODS
		// ====================
		async loadContractsForSociety(societyId) {
			return new Promise((resolve, reject) => {
				Contract.getContractsforSociety(societyId, (err, res) => {
					if (err) {
						reject(err);
						return;
					}

					if (res) {
						this.contractOptions = res.filter((row) =>
							[1, 3, 4].includes(row.status)
						);

						// Auto-select if only one option or restore previous selection
						if (this.contractOptions.length === 1) {
							this.selectedContract = this.contractOptions[0].id;
						} else if (
							this.isInitialized &&
							this.contractOptions.length === 0
						) {
							this.selectedContract = null;
						}
					}

					resolve(res);
				});
			});
		},

		async loadMissionsForContract(contractId) {
			return new Promise((resolve, reject) => {
				Mission.getMissionsForContract(contractId, (err, res) => {
					if (err) {
						reject(err);
						return;
					}

					if (res) {
						this.missionsOfSociety = res;
						this.buildProductOptions();
					}

					resolve(res);
				});
			});
		},

		buildProductOptions() {
			const missionList = [];

			for (let mission of this.missionsOfSociety) {
				const product = this.products.find((p) => p.id === mission.products_id);
				if (!product) continue;

				let item;
				if (mission.commentary) {
					item = `${mission.id} - ${product.perform}: ${mission.commentary}`;
				} else {
					item = `${mission.id} - ${product.perform}`;
				}

				missionList.push([mission.id, item]);
			}

			this.productOptions = missionList;

			// Auto-select if only one option or restore previous selection
			if (this.productOptions.length === 1 && !this.isInitialized) {
				this.selectedProduct = this.productOptions[0][0];
			} else if (this.isInitialized && this.productOptions.length === 0) {
				this.selectedProduct = null;
			}
		},

		async loadServiceOptionsForProvider(providerId) {
			const provider = this.providers.find((p) => p.id === providerId);
			if (!provider) return;

			this.serviceOptions = provider.service_id_list
				.split(",")
				.map((id) => parseInt(id));

			// Auto-select first service if not initialized
			if (this.serviceOptions.length > 0 && !this.isInitialized) {
				this.selectedService = this.serviceOptions[0];
			}
		},

		async loadServiceOptionsAndSetService(providerId, serviceId) {
			try {
				const response = await this.$http.get(
					this.apiUrl + "providersServices/getsu/" + providerId
				);

				this.serviceOptions = response.data.map(
					(service) => service.service_id
				);
				this.selectedService = serviceId;
			} catch (error) {
				console.error("Error loading service options:", error);
				// Fallback to basic service options
				await this.loadServiceOptionsForProvider(providerId);
			}
		},

		// ====================
		// SERVICE UTILITY METHODS
		// ====================
		updateServiceFlags(serviceId) {
			this.is_netlink = this.checkServiceIsNetlink(serviceId);
			this.is_dns = this.checkServiceIsDns(serviceId);
			this.is_dnsclient = serviceId === this.dnsClientServiceId;
			this.is_netlinkclient = serviceId === this.netlinkClientServiceId;
		},

		setNetlinkAndDnsId() {
			if (!this.services || this.services.length === 0) return;

			this.netlinkServiceId = this.getServiceId(this.netlinkServiceName);
			this.dnsServiceId = this.getServiceId(this.dnsServiceName);
			this.dnsClientServiceId = this.getServiceId(this.dnsClientServiceName);
			this.netlinkClientServiceId = this.getServiceId(
				this.netlinkClientServiceName
			);
		},

		getServiceId(serviceName) {
			const service = this.services.find((s) => s.name === serviceName);
			return service ? service.id : null;
		},

		getServiceName(serviceId) {
			const service = this.services.find((s) => s.id == serviceId);
			return service ? service.name : "";
		},

		checkServiceIsNetlink(serviceId) {
			const service = this.services.find((s) => s.id == serviceId);
			return service && service.name === this.netlinkServiceName;
		},

		checkServiceIsDns(serviceId) {
			const service = this.services.find((s) => s.id == serviceId);
			return service && service.name === this.dnsServiceName;
		},

		// ====================
		// STORE DISPATCH METHODS
		// ====================
		getAllProductsCategories() {
			return this.$store.dispatch("getAllProductsCategories");
		},

		getAllSocieties() {
			return this.$store.dispatch("getAllSocieties");
		},

		getAllProviders() {
			return this.$store.dispatch("getAllProviders");
		},

		getAllServices() {
			return this.$store.dispatch("getAllServices");
		},

		getAllDns() {
			return this.$store.dispatch("getAllDns");
		},

		// ====================
		// VALIDATION METHODS
		// ====================
		validateOne(val, name) {
			let value = val;
			value === 0 ? (value = "0") : "";
			let constname = "";
			if (name == "selectedDate") {
				constname = "dateConstraint";
				this.validators[name] = new Validator({ constraintName: constname });
				if (this.selectedDate == 0 || this.selectedDate == null) {
					this.validators[name].valid = false;
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.check = false;
				} else {
					this.validators["selectedDate"].errText = "";
					this.validators[name].valid = true;
				}
			} else {
				switch (name) {
					case "selectedPrice":
					case "selectedSellPrice":
						value ? (value = String(val)) : "";
						constname = "priceConstraint";
						break;
					default:
						value ? (value = String(val)) : "";
						value == null ? (value = "") : "";
						constname = "isNumberConstraint";
						break;
				}
				this.validators[name] = new Validator({ constraintName: constname });
				this.validators[name].check(value);
				val == null ? (this.validators[name].valid = false) : "";
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
					? (this.validators[name].errText = "Ce champ ne peut être vide.")
					: "";
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
					? (this.check = false)
					: "";
			}
			this.$forceUpdate();
		},

		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},

		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				switch (name) {
					case "selectedDate":
						return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid red !important; border-radius: 5px;";
				}
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				switch (name) {
					case "selectedDate":
						return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid green !important; border-radius: 5px;";
				}
			} else {
				return "border: none !important; border-radius: none;";
			}
		},

		// ====================
		// FORM SUBMISSION METHODS
		// ====================
		submitForm() {
			this.check = true;
			let fields = [
				"selectedSociety",
				"selectedContract",
				"selectedProduct",
				"selectedService",
				"selectedProvider",
				"selectedPrice",
				"selectedSellPrice",
			];
			let fieldsVal = [
				this.selectedSociety,
				this.selectedContract,
				this.selectedProduct,
				this.selectedService,
				this.selectedProvider,
				this.selectedPrice,
				this.selectedSellPrice,
			];
			let constname = "";

			if (this.is_dns) {
				fields = [
					"selectedSociety",
					"selectedService",
					"selectedProvider",
					"selectedPrice",
					"selectedSellPrice",
				];
				fieldsVal = [
					this.selectedSociety,
					this.selectedService,
					this.selectedProvider,
					this.selectedPrice,
					this.selectedSellPrice,
				];
			}

			for (let i = 0; i < fields.length; i++) {
				let value = fieldsVal[i];
				if (value === 0) value = "0";
				switch (fields[i]) {
					case "selectedPrice":
					case "selectedSellPrice":
						value = value ? String(value).replace(/\s/g, "") : "";
						constname = "priceConstraint";
						break;
					default:
						value = value ? String(value) : "";
						if (value == null) value = "";
						constname = "isNumberConstraint";
						break;
				}

				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				if (fieldsVal[i] == null) this.validators[fields[i]].valid = false;
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				)
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
				if (fields[i] == "selectedSellPrice" || fields[i] == "selectedPrice") {
					if (this.selectedService == 30 && this.selectedService == 29) {
						this.validators[fields[i]].valid = true;
						this.validators[fields[i]].errText = "";
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
			}

			this.validators["selectedDate"] = new Validator({
				constraintName: "dateConstraint",
			});
			if (this.selectedDate == 0 || this.selectedDate == null) {
				this.validators["selectedDate"].valid = false;
				this.validators["selectedDate"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			} else {
				this.validators["selectedDate"].errText = "";
				this.validators["selectedDate"].valid = true;
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.selectedPrice = Number(
					String(this.selectedPrice).replace(",", ".")
				);
				this.selectedMarginPrice = Number(
					String(this.selectedMarginPrice).replace(",", ".")
				);
				this.selectedSellPrice = Number(
					String(this.selectedSellPrice).replace(",", ".")
				);
				this.purchase.marginRate = Number(
					String(this.purchase.marginRate).replace(",", ".")
				);

				return new Promise((resolve, reject) => {
					if (this.selectedService == this.dnsServiceId) {
						this.editPurchase(true)
							.then((result) => {
								this.editDNS()
									.then((result2) => {
										this.returnPrevRoute();
									})
									.catch((err2) => {
										console.log(err2);
										reject(err2);
									});
							})
							.catch((err) => {
								console.log(err);
								reject(err);
							});
					} else if (this.selectedService == this.netlinkServiceId) {
						this.editPurchase()
							.then((result) => {
								this.updateNetlink()
									.then((result2) => {
										this.returnPrevRoute();
										resolve(result2);
									})
									.catch((err2) => {
										console.log(err2);
										reject(err2);
									});
							})
							.catch((err) => {
								console.log(err);
								reject(err);
							});
					} else {
						this.editPurchase()
							.then((result) => {
								this.returnPrevRoute();
								resolve(result);
							})
							.catch((err) => {
								console.log(err);
								reject(err);
							});
					}
				});
			}
		},

		formSubmittedAndShowNetlink() {
			this.check = true;
			let fields = [
				"selectedSociety",
				"selectedContract",
				"selectedService",
				"selectedProvider",
				"selectedPrice",
				"selectedSellPrice",
			];
			let fieldsVal = [
				this.selectedSociety,
				this.selectedContract,
				this.selectedService,
				this.selectedProvider,
				this.selectedPrice,
				this.selectedSellPrice,
			];
			let constname = "";

			for (let i = 0; i < fields.length; i++) {
				let value = fieldsVal[i];
				value === 0 ? (value = "0") : "";
				switch (fields[i]) {
					case "selectedPrice":
					case "selectedSellPrice":
						value ? (value = String(value)) : "";
						constname = "priceConstraint";
						break;
					default:
						value ? (value = String(value)) : "";
						value == null ? (value = "") : "";
						constname = "isNumberConstraint";
						break;
				}

				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				fieldsVal[i] == null ? (this.validators[fields[i]].valid = false) : "";
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText == ""
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				if (fields[i] == "selectedSellPrice" || fields[i] == "selectedPrice") {
					if (this.selectedService == 30 && this.selectedService == 29) {
						this.selectedMarginPrice = null;
						this.purchase.marginRate = null;
						this.validators[fields[i]].valid = true;
						this.validators[fields[i]].errText = "";
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
			}

			this.validators["selectedDate"] = new Validator({
				constraintName: "dateConstraint",
			});
			if (this.selectedDate == 0 || this.selectedDate == null) {
				this.validators["selectedDate"].valid = false;
				this.validators["selectedDate"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			} else {
				this.validators["selectedDate"].errText = "";
				this.validators["selectedDate"].valid = true;
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.selectedPrice = Number(
					String(this.selectedPrice).replace(",", ".")
				);
				this.selectedMarginPrice = Number(
					String(this.selectedMarginPrice).replace(",", ".")
				);
				this.selectedSellPrice = Number(
					String(this.selectedSellPrice).replace(",", ".")
				);
				this.purchase.marginRate = Number(
					String(this.purchase.marginRate).replace(",", ".")
				);
				this.purchaseLocked = true;
				this.purchaseDefinitiveLock = true;
				this.showNetlinkPopup = true;
			}
		},

		formSubmittedAndShowDns() {
			this.check = true;
			let fields = [
				"selectedSociety",
				"selectedService",
				"selectedProvider",
				"selectedPrice",
				"selectedSellPrice",
			];
			let fieldsVal = [
				this.selectedSociety,
				this.selectedService,
				this.selectedProvider,
				this.selectedPrice,
				this.selectedSellPrice,
			];
			let constname = "";

			for (let i = 0; i < fields.length; i++) {
				let value = fieldsVal[i];
				value === 0 ? (value = "0") : "";
				switch (fields[i]) {
					case "selectedPrice":
					case "selectedSellPrice":
						value ? (value = String(value)) : "";
						constname = "priceConstraint";
						break;
					default:
						value ? (value = String(value)) : "";
						value == null ? (value = "") : "";
						constname = "isNumberConstraint";
						break;
				}

				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				fieldsVal[i] == null ? (this.validators[fields[i]].valid = false) : "";
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText == ""
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				if (fields[i] == "selectedSellPrice" || fields[i] == "selectedPrice") {
					if (this.selectedService == 30 && this.selectedService == 29) {
						this.selectedMarginPrice = null;
						this.purchase.marginRate = null;
						this.validators[fields[i]].valid = true;
						this.validators[fields[i]].errText = "";
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
			}

			this.validators["selectedDate"] = new Validator({
				constraintName: "dateConstraint",
			});
			if (this.selectedDate == 0 || this.selectedDate == null) {
				this.validators["selectedDate"].valid = false;
				this.validators["selectedDate"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			} else {
				this.validators["selectedDate"].errText = "";
				this.validators["selectedDate"].valid = true;
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.selectedPrice = Number(
					String(this.selectedPrice).replace(",", ".")
				);
				this.selectedMarginPrice = Number(
					String(this.selectedMarginPrice).replace(",", ".")
				);
				this.selectedSellPrice = Number(
					String(this.selectedSellPrice).replace(",", ".")
				);
				this.purchase.marginRate = Number(
					String(this.purchase.marginRate).replace(",", ".")
				);
				this.showDnsPopup = true;
			}
		},

		// ====================
		// PURCHASE EDIT METHODS
		// ====================
		editPurchase(isDNS = false) {
			return new Promise((resolve, reject) => {
				let today = new Date(Date.now());
				let formatedDate = this.selectedDate
					? this.selectedDate.split("/").reverse().join("-")
					: today.toISOString().substring(0, 10);

				let period = `${this.purchase.period_date
					.split("/")
					.reverse()
					.join("-")}-01 02:00:00`;

				if (isDNS == true) {
					this.$refs.dnsPurchasePopup.getPurchasePrice().then((result) => {
						this.purchase.price = result;
						this.$http
							.post(this.apiUrl + "purchase/edit", {
								id: this.purchaseId,
								price: this.convertFrenchNumberToInternational(
									this.purchase.price
								),
								recurrence: this.purchase.recurrence,
								sell_price: this.convertInternationalNumberToFrench(
									this.selectedSellPrice
								),
								margin_price: this.convertFrenchNumberToInternational(
									this.selectedMarginPrice
								),
								margin_rate: this.purchase.marginRate,
								is_billable: this.purchase.isBillable,
								commentary: this.purchase.commentary,
								bought_at: formatedDate,
								contract_id: 1,
								contract_society_id: this.selectedSociety,
								users_id: this.selectedProvider,
								service_id: this.selectedService,
								is_delivered: 0,
								recurrence_active: this.purchase.recurrence,
								user_id: this.purchase.user_id,
								period_date: period,
								mission_id: this.is_dns
									? this.missionsOfSociety.filter(
											(mission) =>
												mission.contract_id == 1 && mission.products_id == 105
									  )[0].id
									: this.selectedProduct,
							})
							.then((res) => {
								this.$store.dispatch("getAllPurchasesWithRecurring");
								this.$vs.notify({
									title: "Succès",
									text: "Achat modifié avec succès.",
								});
								resolve(res);
							})
							.catch((err) => {
								console.log(err);
								this.$vs.notify({
									title: "Echec",
									text: "L'achat n'a pas été modifié.",
								});
								reject(null);
							});
					});
				} else {
					this.$http
						.post(this.apiUrl + "purchase/edit", {
							id: this.purchaseId,
							price: this.convertFrenchNumberToInternational(
								this.selectedPrice
							),
							recurrence: this.purchase.recurrence,
							sell_price: this.convertFrenchNumberToInternational(
								this.selectedSellPrice
							),
							margin_price: this.convertFrenchNumberToInternational(
								this.selectedMarginPrice
							),
							margin_rate: this.purchase.marginRate,
							is_billable: this.purchase.isBillable,
							commentary: this.purchase.commentary,
							bought_at: formatedDate,
							contract_id: this.selectedContract,
							contract_society_id: this.selectedSociety,
							users_id: this.selectedProvider,
							service_id: this.selectedService,
							is_delivered: 0,
							recurrence_active: this.purchase.recurrence,
							user_id: this.purchase.user_id,
							period_date: period,
							mission_id: this.is_dns
								? this.missionsOfSociety.filter(
										(mission) =>
											mission.contract_id == 1 && mission.products_id == 105
								  )[0].id
								: this.selectedProduct,
						})
						.then((res) => {
							this.$store.dispatch("getAllPurchasesWithRecurring");
							this.$vs.notify({
								title: "Succès",
								text: "Achat modifié avec succès.",
							});
							resolve(res);
						})
						.catch((err) => {
							console.log(err);
							this.$vs.notify({
								title: "Echec",
								text: "L'achat n'a pas été modifié.",
							});
							reject(null);
						});
				}
			});
		},

		editDNS() {
			return new Promise((resolve, reject) => {
				this.$refs.dnsPurchasePopup
					.updateDnsForPurchase()
					.then((result) => {
						resolve(result);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		updateNetlink(isDNS = false) {
			return new Promise((resolve, reject) => {
				this.netlink_list = this.$refs.netlinkPopup.getNetlinkListData();
				let params = {
					purchase_id: this.purchaseId,
					society_id: this.selectedSociety,
					contract_id: this.selectedContract,
					netlinks: JSON.stringify(this.netlink_list),
					editMain: this.$refs.netlinkPopup.getIsOriginalPurchase(),
				};

				this.$http
					.post(this.apiUrl + "netlink/update", params)
					.then((response) => {
						resolve(response);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		// ====================
		// UI ACTION METHODS
		// ====================
		returnPrevRoute() {
			this.$router.go(-1);
		},

		showNetlink() {
			this.showNetlinkPopup = true;
			this.$store.dispatch("getAllPurchasesWithRecurring");
		},

		displayMissionsPopup() {
			this.showMissionsPopup = true;
		},

		enterEditMode() {
			if (!this.atLeastOneNetlink) {
				this.purchaseDefinitiveLock = false;
			}
			this.showNetlinkPopup = false;
			this.purchaseLocked = false;
		},

		checkNetlinkNumber(netlinkNumber) {
			if (netlinkNumber >= 1) {
				this.atLeastOneNetlink = true;
			} else {
				this.atLeastOneNetlink = false;
				if (!this.purchaseLocked) {
					this.purchaseDefinitiveLock = false;
				}
			}
		},

		// ====================
		// UTILITY METHODS
		// ====================
		getFormatedDate(date) {
			let today = new Date(Date.now());
			return date
				? date.substring(0, 10)
				: today.toISOString().substring(0, 10);
		},
	},
};
</script>

<style>
#product_options > .input-select-con {
	width: 400px;
}

.nowrap {
	display: flex;
	align-items: baseline;
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.overflow_auto {
	overflow: auto;
}

/* Right alignment styles */
.text-right {
	text-align: right;
}

.justify-end {
	justify-content: flex-end;
}

.items-center {
	align-items: center;
}

/* Form field styling for right alignment */
.vx-row.justify-end .vx-col {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.vx-row.justify-end .vx-col > label {
	width: 100%;
	margin-bottom: 8px;
}

.vx-row.justify-end .vx-col > div {
	width: 100%;
}

/* Input group alignment */
.vx-input-group {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

/* Select dropdown right alignment */
.vs-select {
	text-align: left;
}

/* Checkbox alignment */
.vs-checkbox {
	justify-self: flex-end;
}
</style>